/**
 * Returns a NumberFormatter based on locale.
 * When locale is not valid `en` is used a default
 */
export function getFormatter(
  locale,
  options?: Partial<Intl.NumberFormatOptions>,
) {
  let formatter;
  try {
    formatter = new Intl.NumberFormat(locale, options);
  } catch {
    formatter = new Intl.NumberFormat('en', options);
  }
  return formatter;
}
